import { Component, OnInit } from '@angular/core';
import {HeaderComponent} from "./header/header.component";
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
})
export class MainComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

  sideBarState:boolean=true;
  toggleSidebar(state) {
    this.sideBarState = state;
  } 
}



// WEBPACK FOOTER //
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/main/main.component.ts